import React, { FC, MouseEventHandler, ReactNode } from 'react';

import { CloseButton } from '../Button';
import s from './styles.scss';

interface Props {
  children: ReactNode;
  close: MouseEventHandler;
}

export const FullscreenDialog: FC<Props> = ({ children, close }) => (
  <div className={s.box} role="dialog">
    <CloseButton middle onClick={close} className={s.x} />
    {children}
  </div>
);
